import React, { FC } from 'react';

import { HelpCenterContainer } from '@/components/HelpCenterContainer/HelpCenterContainer';

type Props = {
	docs?: string;
};

export const HelpCenter: FC<Props> = () => {
	return <HelpCenterContainer />;
};

export default HelpCenter;
